/* This is a mst-gql generated file, don't modify it manually */
/* eslint-disable */
/* tslint:disable */

import { types } from "mobx-state-tree"
import { MSTGQLRef, QueryBuilder, withTypedRefs } from "mst-gql"
import { ModelBase } from "./ModelBase"
import { AssignActionStatusDtoModel, AssignActionStatusDtoModelType } from "./AssignActionStatusDtoModel"
import { AssignActionStatusDtoModelSelector } from "./AssignActionStatusDtoModel.base"
import { SolutionStatusDtoModel, SolutionStatusDtoModelType } from "./SolutionStatusDtoModel"
import { SolutionStatusDtoModelSelector } from "./SolutionStatusDtoModel.base"
import { RootStoreType } from "./index"


/* The TypeScript type that explicits the refs to other models in order to prevent a circular refs issue */
type Refs = {
  assignAction: AssignActionStatusDtoModelType;
}

/**
 * SolutionStatusOnlyDtoBase
 * auto generated base class for the model SolutionStatusOnlyDtoModel.
 */
export const SolutionStatusOnlyDtoModelBase = withTypedRefs<Refs>()(ModelBase
  .named('SolutionStatusOnlyDto')
  .props({
    __typename: types.optional(types.literal("SolutionStatusOnlyDto"), "SolutionStatusOnlyDto"),
    id: types.identifier,
    projectId: types.union(types.undefined, types.integer),
    actionType: types.union(types.undefined, types.string),
    solutionStatus: types.union(types.undefined, types.late((): any => SolutionStatusDtoModel)),
    assignAction: types.union(types.undefined, types.null, MSTGQLRef(types.late((): any => AssignActionStatusDtoModel))),
  })
  .views(self => ({
    get store() {
      return self.__getStore<RootStoreType>()
    }
  })))

export class SolutionStatusOnlyDtoModelSelector extends QueryBuilder {
  get id() { return this.__attr(`id`) }
  get projectId() { return this.__attr(`projectId`) }
  get actionType() { return this.__attr(`actionType`) }
  solutionStatus(builder: string | SolutionStatusDtoModelSelector | ((selector: SolutionStatusDtoModelSelector) => SolutionStatusDtoModelSelector) | undefined) { return this.__child(`solutionStatus`, SolutionStatusDtoModelSelector, builder) }
  assignAction(builder: string | AssignActionStatusDtoModelSelector | ((selector: AssignActionStatusDtoModelSelector) => AssignActionStatusDtoModelSelector) | undefined) { return this.__child(`assignAction`, AssignActionStatusDtoModelSelector, builder) }
}
export function selectFromSolutionStatusOnlyDto() {
  return new SolutionStatusOnlyDtoModelSelector()
}

export const solutionStatusOnlyDtoModelPrimitives = selectFromSolutionStatusOnlyDto().projectId.actionType
